import React from "react";
const searchSuggestions = [
  {
    entry: [
      {
        resource: {
          gender: "",
          cardType: "",
          cardNumber: "",
          mobilenumber: "",
          name: [{ given: [""], family: "" }],
          birthDate: "",
        },
      },
    ],
  },
];
const SuggestionContext = React.createContext({
  searchSuggestions,
  setSearchSuggestion: (list: any) => {},
});

export default SuggestionContext;
